import React from 'react'
import { ViewTabs } from '@/components/ui/tabs'
import { ClientDto } from 'api/Clients/Types/Client'
import { WalletDto } from 'api/Wallet/Types/Wallet'

import { AdjustmentTradingAccountPage } from './AdjustmentTradingAccountPage'
import { AdjustmentWalletPage } from './AdjustmentWalletPage'

enum AdjustmentType {
  Wallet = 'wallet',
  TradingAccount = 'trading-account',
}

interface OuterProps {
  client: ClientDto | null
  preSelectedWallet?: WalletDto
  setClient(): void
}

export const CreateAdjustmentTabs: React.FC<OuterProps> = (props) => {
  return (
    <ViewTabs
      defaultKey={AdjustmentType.Wallet}
      tabs={[
        {
          key: AdjustmentType.Wallet,
          translateKey: <span>Wallet</span>,
          visible: true,
          component: <AdjustmentWalletPage {...props} />,
        },
        {
          key: AdjustmentType.TradingAccount,
          translateKey: <span>Trading Account</span>,
          visible: true,
          component: <AdjustmentTradingAccountPage {...props} />,
        },
      ]}
    />
  )
}
